import React, { useState } from 'react';
import { Button, Col, Form, Row, Space, Switch, Typography } from 'antd';
import styled from 'styled-components';

const ActiveRight = styled.div`
  text-align: right !important;
`;

type FourthStepProps = {
  goToPrevious: () => void;
  fourthStepData: FourthStepFormInputs | null;
  onCreateCardProduct: (data: FourthStepFormInputs) => void;
  isLoading: boolean;
};

export type FourthStepFormInputs = {
  cvv: boolean,
  expDate: boolean,
  physical: boolean,
  virtual: boolean
};

const FourthStep: React.FC<FourthStepProps> = ({ goToPrevious, fourthStepData, onCreateCardProduct, isLoading }) => {
  const [form] = Form.useForm();
  const [physical, setPhysical] = useState(true);
  const [virtual, setVirtual] = useState(true);
  const [expDate, setExpDate] = useState(true);
  const [cvv, setCvv] = useState(true);

  const onSubmit = (data: FourthStepFormInputs) => {
    data.cvv = cvv;
    data.expDate = expDate;
    data.virtual = virtual;
    data.physical = physical;
    onCreateCardProduct(data);
  }

  return (
    <Form<FourthStepFormInputs>
      layout="horizontal"
      onFinish={onSubmit}
      initialValues={fourthStepData || undefined}
      form={form}
      style={{ width: 'max-content', maxWidth: '100%', margin: 'auto' }}
    >
      <Typography.Title style={{ textAlign: 'center' }} level={2}>Configuraciones</Typography.Title>
      <Row gutter={10}>
        <Col span={24}>
          <Form.Item<FourthStepFormInputs>
            label="Permite aprobar sin verificar CVV2?"
            name="cvv"
            initialValue={cvv}
            rules={[{required: true}]}
          >
            <ActiveRight>
              <Switch onChange={() => setCvv(!cvv)} defaultChecked/>
            </ActiveRight>
          </Form.Item>
          <Form.Item<FourthStepFormInputs>
            label="Permite aprobar transacciones sin verificar la fecha de expiración de la tarjeta?"
            name="expDate"
            initialValue={expDate}
            rules={[{required: true}]}
          >
            <ActiveRight>
              <Switch onChange={() => setExpDate(!expDate)} defaultChecked/>
            </ActiveRight>
          </Form.Item>
          <Form.Item<FourthStepFormInputs>
            label="Permite crear tarjetas virtuales?"
            name="virtual"
            initialValue={virtual}
            rules={[{required: true}]}
          >
            <ActiveRight>
              <Switch onChange={() => setVirtual(!virtual)} defaultChecked/>
            </ActiveRight>
          </Form.Item>
          <Form.Item<FourthStepFormInputs>
            label="Permite crear tarjetas Fisicas?"
            name="physical"
            initialValue={physical}
            rules={[{required: true}]}
          >
            <ActiveRight>
              <Switch onChange={() => setPhysical(!physical)} defaultChecked/>
            </ActiveRight>
          </Form.Item>
        </Col>
      </Row>
      <Form.Item style={{ textAlign: 'center' }}>
        <Space>
          <Button onClick={goToPrevious}>Anterior</Button>
          <Button loading={isLoading} htmlType="submit" type="primary">Crear</Button>
        </Space>
      </Form.Item>
    </Form>
  );
}

export default FourthStep;
